export default __webpack_public_path__ + "static/2000b-2791166664ca9dbb4ab989557b122896.png";